export const GET_STATUSES = "GET_STATUSES";
export const GET_LIST_STATUSES = "GET_LIST_STATUSES";
export const GET_STATUS = "GET_STATUS";
export const SET_STATUSES = "SET_STATUSES";
export const SET_LIST_STATUSES = "SET_LIST_STATUSES";
export const SET_STATUS = "SET_STATUS";
export const ADD_STATUS = "ADD_STATUS";
export const SET_NEW_STATUS = "SET_NEW_STATUS";
export const EDIT_STATUS = "EDIT_STATUS";
export const SET_EDIT_STATUS = "SET_EDIT_STATUS";
export const SET_DELETE_STATUS = "SET_DELETE_STATUS";
export const SET_DELETE_MULTI_STATUS = "SET_DELETE_MULTI_STATUS";
export const DELETE_STATUS = "DELETE_STATUS";
export const DELETE_MULTI_STATUS = "DELETE_MULTI_STATUS";
export const RESET_ITEMS_STATUS = "RESET_ITEMS_STATUS";
export const RESET_SELECTED_STATUS = "RESET_SELECTED_STATUS";
export const RESET_LIST_STATUSES = "RESET_LIST_STATUSES";
